import { Heart, MessageCircle, Mail, Instagram, Settings } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-roca-blue-dark text-white py-6 sm:py-12" role="contentinfo" aria-label="Pied de page">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Mobile: compact 2-column layout */}
        <div className="sm:hidden">
          <div className="flex items-center justify-between mb-4">
            <img 
              src="/lovable-uploads/2b4cc97e-392f-4df4-85e5-ce8b66a05815.png?width=150" 
              alt="Roca Rio" 
              className="h-6 w-auto"
              width="1536"
              height="1024"
            />
            <div className="flex items-center gap-3">
              <a href="https://wa.me/+5521976795050" className="text-white/80 hover:text-roca-orange" aria-label="WhatsApp">
                <MessageCircle className="h-5 w-5" />
              </a>
              <a href="mailto:contact.rocario@gmail.com" className="text-white/80 hover:text-roca-orange" aria-label="Email">
                <Mail className="h-5 w-5" />
              </a>
              <a href="https://instagram.com/roca.rio_" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-roca-orange" aria-label="Instagram">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-white/70 mb-3">
            <a href="/excursions" className="hover:text-roca-orange">Excursions</a>
            <a href="/a-propos" className="hover:text-roca-orange">À propos</a>
            <a href="/contact" className="hover:text-roca-orange">Contact</a>
            <a href="/avis" className="hover:text-roca-orange">Avis</a>
          </div>
        </div>

        {/* Desktop/Tablet: original 3-column grid */}
        <div className="hidden sm:grid grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {/* Brand & Mission */}
          <div>
            <div className="flex items-center mb-3 sm:mb-4">
              <img 
                src="/lovable-uploads/2b4cc97e-392f-4df4-85e5-ce8b66a05815.png?width=150" 
                srcSet="/lovable-uploads/2b4cc97e-392f-4df4-85e5-ce8b66a05815.png?width=75 1x, /lovable-uploads/2b4cc97e-392f-4df4-85e5-ce8b66a05815.png?width=150 2x"
                alt="Roca Rio - Agence de tourisme solidaire à Rio de Janeiro" 
                className="h-7 sm:h-8 w-auto"
                width="1536"
                height="1024"
              />
            </div>
            <p className="text-white/80 text-sm sm:text-base mb-3 sm:mb-4 leading-relaxed">
              Agence de tourisme locale & engagée à Rio de Janeiro. 
              Des expériences authentiques et immersives.
            </p>
            <div className="flex items-center text-accent">
              <Heart className="h-4 w-4 sm:h-5 sm:w-5 mr-2 flex-shrink-0" />
              <span className="text-xs sm:text-sm">Excursions solidaires</span>
            </div>
          </div>

          {/* Navigation & Contact */}
          <nav aria-label="Navigation du pied de page">
            <h4 className="font-semibold text-base sm:text-lg mb-3 sm:mb-4 text-roca-orange uppercase tracking-wide">Liens</h4>
            <ul className="space-y-2">
              <li><a href="/excursions" className="block text-sm sm:text-base text-white/80 hover:text-roca-orange transition-smooth py-1">Nos excursions</a></li>
              <li><a href="/a-propos" className="block text-sm sm:text-base text-white/80 hover:text-roca-orange transition-smooth py-1">À propos</a></li>
              <li><a href="/contact" className="block text-sm sm:text-base text-white/80 hover:text-roca-orange transition-smooth py-1">Contact</a></li>
              <li><a href="/avis" className="block text-sm sm:text-base text-white/80 hover:text-roca-orange transition-smooth py-1">Avis clients</a></li>
              <li>
                <a href="/admin" className="flex items-center text-sm sm:text-base text-white/80 hover:text-roca-orange transition-smooth py-1">
                  <Settings className="h-4 w-4 mr-2 flex-shrink-0" aria-hidden="true" />
                  <span>Admin</span>
                </a>
              </li>
            </ul>
          </nav>

          {/* Contact & Social */}
          <div>
            <h4 className="font-semibold text-base sm:text-lg mb-3 sm:mb-4 text-roca-orange uppercase tracking-wide">Nous joindre</h4>
            <ul className="space-y-2 sm:space-y-3 mb-4 sm:mb-6">
              <li>
                <a href="https://wa.me/+5521976795050" className="flex items-center text-sm sm:text-base text-white/80 hover:text-roca-orange transition-smooth py-1" aria-label="Contactez-nous sur WhatsApp">
                  <MessageCircle className="h-4 w-4 mr-2 sm:mr-3 flex-shrink-0" aria-hidden="true" />
                  WhatsApp
                </a>
              </li>
              <li>
                <a href="mailto:contact.rocario@gmail.com" className="flex items-center text-sm sm:text-base text-white/80 hover:text-roca-orange transition-smooth py-1" aria-label="Envoyez-nous un email">
                  <Mail className="h-4 w-4 mr-2 sm:mr-3 flex-shrink-0" aria-hidden="true" />
                  Email
                </a>
              </li>
            </ul>
            <ul className="space-y-2">
              <li>
                <a href="https://instagram.com/roca.rio_" target="_blank" rel="noopener noreferrer" className="flex items-center text-sm sm:text-base text-white/80 hover:text-roca-orange transition-smooth py-1" aria-label="@roca.rio_">
                  <Instagram className="h-4 w-4 mr-2 sm:mr-3 flex-shrink-0" aria-hidden="true" />
                  @roca.rio_
                </a>
              </li>
              <li>
                <a href="https://instagram.com/meninos.dobrasil" target="_blank" rel="noopener noreferrer" className="flex items-center text-sm sm:text-base text-white/80 hover:text-accent transition-smooth py-1" aria-label="@meninos.dobrasil">
                  <Instagram className="h-4 w-4 mr-2 sm:mr-3 flex-shrink-0" aria-hidden="true" />
                  @meninos.dobrasil
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-6 sm:mt-8 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-4">
            <p className="text-white/60 text-xs sm:text-sm">
              © 2025 Roca Rio
            </p>
            <nav aria-label="Liens légaux" className="flex flex-wrap justify-center gap-3 sm:gap-6 text-xs sm:text-sm">
              <a href="/mentions-legales" className="text-white/60 hover:text-roca-orange transition-smooth rounded py-1">
                Mentions légales
              </a>
              <a href="/confidentialite" className="text-white/60 hover:text-roca-orange transition-smooth rounded py-1">
                Confidentialité
              </a>
              <button 
                onClick={() => {
                  const event = new CustomEvent('openCookieSettings');
                  window.dispatchEvent(event);
                }}
                className="text-white/60 hover:text-roca-orange transition-smooth rounded py-1"
                aria-label="Gérer les préférences des cookies"
              >
                Cookies
              </button>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};